import styled, { css } from 'styled-components';
import Button from '../../../_shared/components/Button';
import applyResponsiveVdpStyles from '../../../_shared/helpers/applyResponsiveVdpStyles';

/**
 * Variant Definitions
 */
const StyledHeaderVariants = {
  mini: css`
    padding: 0 18px;
    align-items: center;
    height: 42px;
  `,
  expanded: css`
    margin: 30px 0 24px;
    color: ${({ theme }) => theme.COLORS.NEUTRAL_30};
  `
};

/**
 * Styled Components
 */
export const StyledHeader = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  ${({ theme }) =>
    applyResponsiveVdpStyles(theme, {
      mini: StyledHeaderVariants.mini,
      expanded: StyledHeaderVariants.expanded
    })}
`;

export const CtaContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ViewItem = styled.div`
  margin-right: 14px;
`;

export const ShareRetailButton = styled(Button)`
  background: ${({ theme }) => theme.COLORS.TRANSPARENT};
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
  margin-right: ${({ addMargin }) => (addMargin ? '24px' : '0px')};
  ${({ addMargin }) => (addMargin ? '' : 'padding-right: 0px;')};

  align-items: center;
  letter-spacing: normal;
  white-space: nowrap;

  svg {
    margin-right: 6px;
    width: 18px;
    height: 18px;
    vertical-align: top;
  }

  &:hover {
    color: ${({ theme }) => theme.COLORS.DARK_BLUE};

    path {
      fill: ${({ theme }) => theme.COLORS.DARK_BLUE};
    }
  }
`;
